import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/logo_black.png'


const _hoisted_1 = { class: "toplogo" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = {
  class: "container",
  id: "myElement"
}
const _hoisted_5 = {
  key: 0,
  class: "content"
}

import { ref, onMounted } from 'vue';
import router from '@/router'; 
    
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const routerName = ref(router.currentRoute)
    const brwidth = ref(0)
    const brheight = ref(0)
    const handleSelect = (key: string, keyPath: string[]) => {
      router.push(keyPath && keyPath[keyPath.length-1])
      // console.log(key, keyPath,keyPath)
    }
    // 监听浏览器窗口宽度变化
    function handleResize() {
      brwidth.value = window.innerWidth;
    }
    // 监听浏览器滚动条高度变化
    function handlepageYOffset() {
      var element = document.getElementById('myElement');
      brheight.value  = element.scrollTop;
    }
    window.addEventListener("scroll", handlepageYOffset, true)
    window.addEventListener('resize', handleResize);
    onMounted(()=>{
        handleResize()
      
      handlepageYOffset()
    })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(routerName.value.name=='home'?'homepage':'otherpage')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass((routerName.value.name=='home' && brheight.value>100)?'scorllheight':'header')
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            ((routerName.value.name=='home' && brheight.value<=100 ))
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : (_openBlock(), _createElementBlock("img", _hoisted_3))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", null, [
        _createVNode(_component_el_menu, {
          class: "el-menu-demo",
          mode: "horizontal",
          onSelect: handleSelect
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "/" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("首页")
              ])),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "2" }, {
              title: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("产品")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/product/chenggui" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("城轨")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/product/railway" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("铁路")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/product/lowaltitude" }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("低空")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/product/emergencyresponse" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("应急")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "3" }, {
              title: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("服务")
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/service/Train" }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("培训")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/service/Competition" }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("竞赛")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/join/joinUs" }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("加入我们")
              ])),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/case/CasePage" }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("案例")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      (routerName.value.name!='home')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_view)
          ]))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
    ]),
    _createVNode(_component_el_backtop, {
      target: ".container",
      right: brwidth.value>1200?100:30,
      bottom: brwidth.value>1200?100:50
    }, null, 8, ["right", "bottom"])
  ], 2))
}
}

})